import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';
import { Tab } from '@instinet-analytics/semantic-ui-components';
import './SupportVisualisationEmbeddedApiTest.scss';
import SupportVisualisationEmbeddedApiTestIn from 'widgets/supportVisualisation/Content/EmbeddedApiTest/SupportVisualisationEmbeddedApiTestIn';
import SupportVisualisationEmbeddedApiTestOut from 'widgets/supportVisualisation/Content/EmbeddedApiTest/SupportVisualisationEmbeddedApiTestOut';
import { useDispatchPortfolioSetActiveInput } from 'portfolio/store/dispatcher';

export default function SupportVisualisationEmbeddedApiTest(
    props: VisualisationContextProps
) {
    const { loadCurrentState, setActiveView } = props;
    const panes: { menuItem: string; render: () => JSX.Element }[] = [];
    const dispatchSetActiveInput = useDispatchPortfolioSetActiveInput();

    const renderTestIn = () => <SupportVisualisationEmbeddedApiTestIn />;
    panes.push({
        menuItem: 'In',
        render: renderTestIn,
    });

    const renderTestOut = () => <SupportVisualisationEmbeddedApiTestOut />;
    panes.push({
        menuItem: 'Out',
        render: renderTestOut,
    });

    const onClickLoadAndViewCurrent = () => {
        loadCurrentState();
        setActiveView('embeddedApiMessages');
    };

    const onClickSetActiveInput = () => {
        dispatchSetActiveInput('Embedded App');
    };

    return (
        <div className="SupportVisualisationEmbeddedApiTest">
            <div className="set-active-input" onClick={onClickSetActiveInput}>
                Set Active Input
            </div>
            <div className="load-and-view" onClick={onClickLoadAndViewCurrent}>
                Load & View Current
            </div>
            <Tab
                panes={panes}
                menu={{ secondary: true, pointing: true, inverted: true }}
            />
        </div>
    );
}
